const defaultState = {
  filter: {},
  page: {},
};

const mutations = {
  SET_ORDER_FILTER(state, filter) {
    state.filter = filter;
  },
  SET_PAGE(state, page) {
    state.page = page;
  },
};

const actions = {
  setOrderFilter({commit}, newValue) {
    commit("SET_ORDER_FILTER", newValue);
  },
  setPage({commit}, newValue) {
    commit("SET_PAGE", newValue);
  },
};

const getters = {
  getOrderFilter: (state) => {
    return state.filter;
  },
  getPage: (state) => {
    return state.page;
  }
};

export default {
  state: defaultState,
  mutations,
  actions,
  getters,
};